import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  REAL_ESTATE_PAGE_READ,
  REAL_ESTATE_TAB_ROUTES,
  REAL_ESTATE_TABS,
} from '~/components/routes/development/real-estate/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/development/real-estate/')({
  staticData: { permission: REAL_ESTATE_PAGE_READ },
  beforeLoad: ({ context, search }) => {
    // `withRoutePermissions` enveloppe ce `beforeLoad` : l'accès est déjà refusé si aucun onglet
    // n'est accessible. On redirige donc vers le premier qui l'est.
    const first = REAL_ESTATE_TABS.find(
      (item) => resolveMissingPermissions(context.ability, item.permission).length === 0,
    )
    throw redirect({
      to: REAL_ESTATE_TAB_ROUTES[first?.value ?? REAL_ESTATE_TABS[0].value],
      replace: true,
      search,
    })
  },
})
withRoutePermissions(Route)
